
		<div class="center-me"><button class="btn btn-primary btn-lg" (click)="launchPhone()">Launch Phone</button></div>
		<div class="center-me"><button *ngIf="showAgentViewButton" class="btn btn-default btn-sm" (click)="launchAgentPhone()">Launch Agent Phone</button></div>
	